// Cabinet configurator data and helper functions - UPDATED PRICING

export const CABINET_IMAGES = {
  hero: "https://images.unsplash.com/photo-1765277789277-86c7b06d5e55?w=800",
  white: "https://images.unsplash.com/photo-1682888818650-0a7cbb35287d?w=800",
  grey: "https://images.unsplash.com/photo-1721614661426-6c9488cae8f3?w=800",
  wood: "https://images.unsplash.com/photo-1771287490583-ab03482ba338?w=800",
  navy: "https://images.unsplash.com/photo-1722859033311-f82770f888a5?w=800",
  modern: "https://images.unsplash.com/photo-1765766601532-90e9b96320c8?w=800",
};

// STANDARD BASE PRICE: $50 for Wall Cabinet, 6" wide, 24" tall
export const STANDARD_BASE_PRICE = 50;
export const STANDARD_WIDTH = 6;
export const STANDARD_HEIGHT = 24;
export const CUSTOM_BASE_PRICE = 100;
export const SIZE_INCREMENT_PRICE = 3; // $3 per inch
export const DEPTH_INCREMENT_PRICE = 7; // $7 per inch for custom depth

// Cabinet Types with multipliers
export const CABINET_TYPES = [
  { id: 'wall', name: 'Wall Cabinet', description: 'Upper wall-mounted cabinet', multiplier: 1.0 },
  { id: 'base', name: 'Base Cabinet', description: 'Standard lower cabinet', multiplier: 1.5 },
  { id: 'base-2door-drawer', name: 'Base Cabinet 2 Door + Drawer', description: 'Base with 2 doors and drawer on top', multiplier: 1.95 }, // 1.5 * 1.3
  { id: '3-drawer-base', name: '3 Drawer Base', description: 'Base cabinet with 3 drawers', multiplier: 2.1 }, // 1.5 * 1.4
  { id: 'corner', name: 'Corner Cabinet', description: 'L-shaped corner solution', multiplier: 1.875 }, // 1.5 * 1.25
  { id: 'blind', name: 'Blind Cabinet', description: 'Blind corner cabinet', multiplier: 1.875 }, // 1.5 * 1.25
];

// Cabinet Box Materials
export const BOX_MATERIALS = [
  { id: 'white-melamine', name: 'White Melamine Cabinet Boxes', description: 'Standard economical option', multiplier: 1.0 },
  { id: 'birch-plywood', name: 'Birch Plywood Cabinet Boxes', description: 'Durable & moisture resistant', multiplier: 1.2 },
  { id: 'maple-plywood', name: 'Maple Plywood Cabinet Boxes', description: 'Premium hardwood plywood', multiplier: 1.25 },
];

// Door Materials
export const DOOR_MATERIALS = [
  { id: 'unfinished-mdf', name: 'Unfinished Raw MDF Doors', description: 'Standard unfinished option', multiplier: 1.0 },
  { id: 'thermofoil-mdf', name: 'Thermofoil MDF Doors', description: 'Heat-wrapped vinyl finish', multiplier: 1.1 },
  { id: 'painted-mdf', name: 'Painted MDF Doors', description: 'Factory painted finish', multiplier: 1.8 },
];

// Door Styles (all 1x multiplier)
export const DOOR_STYLES = [
  { id: 'shaker', name: 'Shaker', description: 'Classic recessed panel', multiplier: 1.0 },
  { id: 'flat-panel', name: 'Flat Panel', description: 'Modern minimalist slab', multiplier: 1.0 },
  { id: 'raised-panel', name: 'Raised Panel', description: 'Traditional elegant profile', multiplier: 1.0 },
  { id: 'glass-front', name: 'Glass Front', description: 'Display-ready with glass', multiplier: 1.0 },
  { id: 'open-shelf', name: 'Open Shelf', description: 'No doors, open storage', multiplier: 1.0 },
];

// Door Colors (all 1x multiplier)
export const COLORS = [
  { id: 'white', name: 'Classic White', hex: '#FFFFFF', multiplier: 1.0, image: 'white' },
  { id: 'antique-white', name: 'Antique White', hex: '#FAEBD7', multiplier: 1.0, image: 'white' },
  { id: 'grey', name: 'Dove Grey', hex: '#6B7280', multiplier: 1.0, image: 'grey' },
  { id: 'charcoal', name: 'Charcoal', hex: '#374151', multiplier: 1.0, image: 'modern' },
  { id: 'navy', name: 'Navy Blue', hex: '#1E3A5F', multiplier: 1.0, image: 'navy' },
  { id: 'sage', name: 'Sage Green', hex: '#9CAF88', multiplier: 1.0, image: 'white' },
  { id: 'natural-oak', name: 'Natural Oak', hex: '#C4A777', multiplier: 1.0, image: 'wood' },
  { id: 'espresso', name: 'Espresso', hex: '#3C2415', multiplier: 1.0, image: 'modern' },
];

// Standard Dimensions
export const WALL_CABINET_WIDTHS = [6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36];
export const WALL_CABINET_HEIGHTS = [24, 30, 34, 36, 42, 44,48,50,52,54,56,58,60];
export const BASE_CABINET_WIDTHS = [6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36];
export const BASE_CABINET_HEIGHT = 34.5; // Fixed height for base cabinets

// Custom size limits
export const MAX_CUSTOM_WIDTH = 40;
export const MAX_CUSTOM_HEIGHT = 96;
export const MIN_CUSTOM_WIDTH = 5;
export const MIN_CUSTOM_HEIGHT = 20;
export const MIN_CUSTOM_DEPTH = 10;
export const MAX_CUSTOM_DEPTH = 24;
export const STANDARD_DEPTH = 12; // Standard wall cabinet depth

// Upgrades
export const UPGRADES = [
  { id: 'soft-close', name: 'Soft-Close Hinges', description: 'Quiet closing', price: 25 },
  { id: 'dovetail', name: 'Dovetail Drawers', description: 'Premium joinery', price: 45 },
  { id: 'full-extension', name: 'Full-Extension Slides', description: '100% access', price: 35 },
  { id: 'led-lighting', name: 'LED Interior Lighting', description: 'Motion-activated', price: 65 },
  { id: 'lazy-susan', name: 'Lazy Susan', description: 'Rotating shelf', price: 120, cornerOnly: true },
  { id: 'pull-out-trash', name: 'Pull-Out Trash', description: 'Hidden bins', price: 85 },
];

// Helper functions
export function findById(arr, id) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].id === id) return arr[i];
  }
  return null;
}

export function getLabel(options, id) {
  const item = findById(options, id);
  return item ? item.name : id;
}

export function getColorImage(colorId) {
  const color = findById(COLORS, colorId);
  if (color && color.image) {
    return CABINET_IMAGES[color.image] || CABINET_IMAGES.white;
  }
  return CABINET_IMAGES.white;
}

// Check if dimensions are standard
export function isStandardDimension(cabinetType, width, height) {
  const isWallType = cabinetType === 'wall';
  
  if (isWallType) {
    const validWidth = WALL_CABINET_WIDTHS.includes(width);
    const validHeight = WALL_CABINET_HEIGHTS.includes(height);
    return validWidth && validHeight;
  } else {
    // Base cabinet types have fixed height
    const validWidth = BASE_CABINET_WIDTHS.includes(width);
    return validWidth;
  }
}

// Find nearest standard dimension for custom pricing
export function findNearestStandardPrice(cabinetType, width, height) {
  const isWallType = cabinetType === 'wall';
  
  let nearestWidth = STANDARD_WIDTH;
  let nearestHeight = STANDARD_HEIGHT;
  
  const widthOptions = isWallType ? WALL_CABINET_WIDTHS : BASE_CABINET_WIDTHS;
  
  // Find nearest width
  for (let i = 0; i < widthOptions.length; i++) {
    if (Math.abs(widthOptions[i] - width) < Math.abs(nearestWidth - width)) {
      nearestWidth = widthOptions[i];
    }
  }
  
  // Find nearest height (only for wall cabinets)
  if (isWallType) {
    for (let i = 0; i < WALL_CABINET_HEIGHTS.length; i++) {
      if (Math.abs(WALL_CABINET_HEIGHTS[i] - height) < Math.abs(nearestHeight - height)) {
        nearestHeight = WALL_CABINET_HEIGHTS[i];
      }
    }
  }
  
  return { nearestWidth, nearestHeight };
}

// Main price calculation function
export function calculatePrice(config) {
  const {
    cabinetType,
    boxMaterial,
    doorMaterial,
    doorStyle,
    color,
    width,
    height,
    customWidth,
    customHeight,
    customDepth,
    useCustomSize,
    quantity,
    upgrades
  } = config;

  // Determine actual dimensions
  const actualWidth = useCustomSize && customWidth ? customWidth : width;
  const actualHeight = useCustomSize && customHeight ? customHeight : height;
  const actualDepth = customDepth || STANDARD_DEPTH;

  // Check if this is a wall cabinet type
  const isWallType = cabinetType === 'wall';
  
  // Check if this is a custom (non-standard) size
  const isCustomSize = useCustomSize && !isStandardDimension(cabinetType, actualWidth, actualHeight);
  
  // For custom sizes, find nearest standard dimensions
  // For standard sizes, use actual dimensions
  let pricingWidth = actualWidth;
  let pricingHeight = actualHeight;
  let nearestInfo = null;
  
  if (isCustomSize) {
    // Find nearest standard dimensions for pricing
    nearestInfo = findNearestStandardPrice(cabinetType, actualWidth, actualHeight);
    pricingWidth = nearestInfo.nearestWidth;
    pricingHeight = nearestInfo.nearestHeight;
  }

  // Step 1: Base price is always $50 (standard base)
  let basePrice = STANDARD_BASE_PRICE; // $50

  // Step 2: Apply cabinet type multiplier
  const cabinetTypeData = findById(CABINET_TYPES, cabinetType);
  const typeMultiplier = cabinetTypeData ? cabinetTypeData.multiplier : 1.0;

  // Step 3: Apply box material multiplier
  const boxMaterialData = findById(BOX_MATERIALS, boxMaterial);
  const boxMultiplier = boxMaterialData ? boxMaterialData.multiplier : 1.0;

  // Step 4: Apply door material multiplier
  const doorMaterialData = findById(DOOR_MATERIALS, doorMaterial);
  const doorMultiplier = doorMaterialData ? doorMaterialData.multiplier : 1.0;

  // Step 5: Apply door style multiplier (all are 1.0)
  const doorStyleData = findById(DOOR_STYLES, doorStyle);
  const styleMultiplier = doorStyleData ? doorStyleData.multiplier : 1.0;

  // Step 6: Apply color multiplier (all are 1.0)
  const colorData = findById(COLORS, color);
  const colorMultiplier = colorData ? colorData.multiplier : 1.0;

  // Calculate multiplied base price
  let calculatedPrice = basePrice * typeMultiplier * boxMultiplier * doorMultiplier * styleMultiplier * colorMultiplier;

  // Step 7: Add size increments ($3 per inch above standard 6" width and 24" height)
  // Use the pricing dimensions (nearest standard for custom, actual for standard)
  const widthIncrement = Math.max(0, pricingWidth - STANDARD_WIDTH) * SIZE_INCREMENT_PRICE;
  
  let heightIncrement = 0;
  if (isWallType) {
    heightIncrement = Math.max(0, pricingHeight - STANDARD_HEIGHT) * SIZE_INCREMENT_PRICE;
  }

  calculatedPrice = calculatedPrice + widthIncrement + heightIncrement;

  // Step 8: If custom size, DOUBLE the price of the nearest standard dimension
  // This is the key logic: price = 2x (price of nearest standard width & height)
  if (isCustomSize) {
    calculatedPrice = calculatedPrice * 2;
  }

  // Step 9: Add depth upgrade if height > 42" and custom depth selected
  let depthUpgradePrice = 0;
  if (actualHeight > 42 && customDepth && customDepth > STANDARD_DEPTH) {
    const extraInches = customDepth - STANDARD_DEPTH;
    depthUpgradePrice = extraInches * DEPTH_INCREMENT_PRICE;
  }

  calculatedPrice = calculatedPrice + depthUpgradePrice;

  // Step 10: Add upgrades
  let upgradesTotal = 0;
  const selectedUpgrades = upgrades || [];
  for (let i = 0; i < selectedUpgrades.length; i++) {
    const upgrade = findById(UPGRADES, selectedUpgrades[i]);
    if (upgrade) {
      upgradesTotal = upgradesTotal + upgrade.price;
    }
  }

  const unitPrice = Math.round(calculatedPrice + upgradesTotal);
  const qty = quantity || 1;
  const totalPrice = unitPrice * qty;

  // Return detailed breakdown
  return {
    unitPrice,
    totalPrice,
    upgradesTotal,
    breakdown: {
      basePrice,
      typeMultiplier,
      boxMultiplier,
      doorMultiplier,
      styleMultiplier,
      colorMultiplier,
      widthIncrement,
      heightIncrement,
      depthUpgradePrice,
      isCustomSize,
      actualWidth,
      actualHeight,
      actualDepth,
      // Include nearest standard info for transparency
      nearestStandardWidth: isCustomSize ? pricingWidth : null,
      nearestStandardHeight: isCustomSize ? pricingHeight : null
    }
  };
}
